// import PropTypes from 'prop-types';
import styles from './Banner.module.scss';

const Banner = ({ text }) => {
    return (
        <div className={styles['Banner']}>
            <div className={styles['Banner__Container']}>
                <span className={styles['Banner__Text']}>{text}</span>
            </div>
        </div>
    );
};

Banner.propTypes = {};

export default Banner;
